/* ==========================================================
   EARTH ENERGY | COMPLETE JOINT SUPPORT LP
   File: assets/ee-joint-lp.js

   >>>>>>>>>>>>>>>>>>>>  CONFIG - READ ME  <<<<<<<<<<<<<<<<<<<<
   1 Bottle price ($42.95) verified from the live PDP 2026-07-09.
   3-Pack ($79.95) and 6-Pack ($137.95) came from a recent PDP
   snapshot. Confirm all three prices match Shopify admin.

   VARIANT IDS ARE PLACEHOLDERS (0). Get the real ones:
   open https://www.earthenergysupplementstore.com/products/joint-support.js
   in your browser. Find "variants" and copy each "id" into the
   matching pack below. Until then, Add to Cart safely falls
   back to the product page instead of erroring.

   SUBSCRIPTIONS: set SUBS_ENABLED to true and fill in the
   "plan" values (search "selling_plan" in the same .js output)
   once you confirm the subscription discount structure.
   ============================================================ */
document.addEventListener("DOMContentLoaded", function () {
  var SUBS_ENABLED = false; /* flip to true after adding plan IDs below */

  var PACKS = {
    "1": { name: "1 Bottle", days: 30, bottles: 1,
           variant: 0, /* REPLACE with 1 Bottle variant id */
           plan: 0,    /* REPLACE with selling plan id, then enable subs */
           once: { price: 42.95, compare: null },
           sub:  { price: 34.36, compare: 42.95, renew: 36.51 } },
    "3": { name: "3-Pack", days: 90, bottles: 3,
           variant: 0, /* REPLACE with 3 Pack variant id */
           plan: 0,
           once: { price: 79.95, compare: 128.85 },
           sub:  { price: 63.96, compare: 128.85, renew: 67.96 } },
    "6": { name: "6-Pack", days: 180, bottles: 6,
           variant: 0, /* REPLACE with 6 Pack variant id */
           plan: 0,
           once: { price: 137.95, compare: 257.70 },
           sub:  { price: 110.36, compare: 257.70, renew: 117.26 } }
  };
  /* compare values above = buying that many single bottles at $42.95 */

  var IMGS = {
    "1": "https://www.earthenergysupplementstore.com/cdn/shop/files/jointsupport_1.webp?v=1762725522",
    "3": "https://www.earthenergysupplementstore.com/cdn/shop/files/jointsupport_2.webp?v=1762781409",
    "6": "https://www.earthenergysupplementstore.com/cdn/shop/files/jointsupport_3.webp?v=1762781409"
  };
  var state = { pack: "3", mode: "once" };
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return "$" + n.toFixed(2); };

  if (!SUBS_ENABLED) {
    var modeRow = document.getElementById("eelp-modes");
    if (modeRow) modeRow.style.display = "none";
    var modeLabel = document.getElementById("eelp-modes-label");
    if (modeLabel) modeLabel.style.display = "none";
  }

  function render() {
    var p = PACKS[state.pack];
    var d = state.mode === "sub" ? p.sub : p.once;
    var perDay = d.price / p.days;
    var perBottle = d.price / p.bottles;

    $("eelp-price").textContent = money(d.price);
    if (d.compare && d.compare > d.price) {
      $("eelp-was").style.display = "inline";
      $("eelp-was").textContent = money(d.compare);
      $("eelp-save").style.display = "inline";
      $("eelp-save").textContent = "You save " + money(d.compare - d.price);
    } else {
      $("eelp-was").style.display = "none";
      $("eelp-save").style.display = "none";
    }
    $("eelp-meta").textContent = money(perBottle) + " per bottle \u00B7 $" + perDay.toFixed(2) + " per day \u00B7 " + p.days + "-day supply";

    var note = $("eelp-subnote");
    if (state.mode === "sub") {
      note.style.display = "block";
      note.textContent = "Renews at " + money(d.renew) + " (15% off for life). Skip, swap, or cancel anytime.";
      $("eelp-atc").textContent = "Subscribe & Save 20%";
    } else {
      note.style.display = "none";
      $("eelp-atc").textContent = "Add to Cart";
    }

    $("eelp-main-img").src = IMGS[state.pack];
    $("eelp-sb-price").textContent = money(d.price);
    $("eelp-sb-meta").textContent = p.name + " \u00B7 $" + perDay.toFixed(2) + "/day";

    document.querySelectorAll("#eelp-packs .pack").forEach(function (el) {
      el.classList.toggle("on", el.getAttribute("data-pack") === state.pack);
      var pk = PACKS[el.getAttribute("data-pack")];
      var dd = state.mode === "sub" ? pk.sub : pk.once;
      el.querySelector('[data-role="pday"]').textContent = "$" + (dd.price / pk.days).toFixed(2) + "/day";
    });
    document.querySelectorAll("#eelp-modes .mode").forEach(function (el) {
      el.classList.toggle("on", el.getAttribute("data-mode") === state.mode);
    });
  }

  document.querySelectorAll("#eelp-packs .pack").forEach(function (el) {
    el.addEventListener("click", function () { state.pack = el.getAttribute("data-pack"); render(); });
  });
  document.querySelectorAll("#eelp-modes .mode").forEach(function (el) {
    el.addEventListener("click", function () { state.mode = el.getAttribute("data-mode"); render(); });
  });
  document.querySelectorAll(".eelp .thumb").forEach(function (el) {
    el.addEventListener("click", function () {
      $("eelp-main-img").src = el.getAttribute("data-img");
      document.querySelectorAll(".eelp .thumb").forEach(function (t) { t.classList.remove("on"); });
      el.classList.add("on");
    });
  });

  $("eelp-atc").addEventListener("click", function () {
    var btn = this;
    var p = PACKS[state.pack];
    if (!p.variant) {
      /* variant ids not configured yet: send buyer to the PDP instead of erroring */
      window.location.href = "/products/joint-support";
      return;
    }
    var item = { id: p.variant, quantity: 1 };
    if (state.mode === "sub" && p.plan) item.selling_plan = p.plan;
    btn.disabled = true;
    btn.textContent = "Adding...";
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart");
      window.location.href = "/checkout";
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = "Add to Cart";
      window.location.href = "/cart/add?id=" + p.variant + "&quantity=1" + (state.mode === "sub" && p.plan ? "&selling_plan=" + p.plan : "");
    });
  });

  document.querySelectorAll(".eelp .faq-q").forEach(function (q) {
    q.addEventListener("click", function () { q.parentElement.classList.toggle("open"); });
  });

  var buy = document.getElementById("buy");
  var bar = $("eelp-sticky");
  window.addEventListener("scroll", function () {
    bar.classList.toggle("show", buy.getBoundingClientRect().bottom < 0);
  }, { passive: true });

  document.querySelectorAll('.eelp a[href="#buy"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      e.preventDefault();
      buy.scrollIntoView({ behavior: "smooth" });
    });
  });

  render();
});
